import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index/Index'
import Login from '@/pages/login/Login'
import RegisterCoach from '@/pages/registerCoach/registerCoach'
import Logon from '@/pages/registerCoach/login_1'
import Apply from '@/pages/apply/Apply'
import Cities from '@/pages/cities/Cities'
import Orderdetail from '@/pages/orderdetail/Orderdetail'
import Order_1 from '@/pages/order/Order_1'
import Checking from '@/pages/checking/Checking'
import Income from '@/pages/income/Income'
import IncomeByDev from '@/pages/income/IncomeByDev'
import Incomedetail from '@/pages/incomedetail/Incomedetail'
import Pay from '@/pages/pay/Pay'
import Buy_1 from '@/pages/buy/Buy_1'
import Paid from '@/pages/buy/paid'
import ComPaid from '@/pages/buy/buyComPaid'
import Address from '@/pages/address/Address'
import Equipment from '@/pages/equipment/Equipment'
import Equipmentdetail from '@/pages/equipmentdetail/Equipmentdetail'
import Buyhistory from '@/pages/buyhistory/Buyhistory'
import Incomeparticulars from '@/pages/incomeparticulars/Incomeparticulars'
import Incomeparticularsdetail from '@/pages/incomeparticularsdetail/Incomeparticularsdetail'
import Incomeorderdetails from '@/pages/incomeorderdetails/Incomeorderdetails'
import Publicity from '@/pages/publicity/publicity'
import ProductDetail_1 from '@/pages/productDetail/productDetail_1'
import ProductDetail_share from '@/pages/productDetail/productDetail_share'
import ProductDetail_sell from '@/pages/productDetail/productDetail_sell'
import protocol from '@/pages/productDetail/protocol'
import SigninPact from '@/pages/pactList/signinPact'
import SettlePact from '@/pages/pactList/settlePact'
import LeasePact from '@/pages/pactList/leasePact'
import LeasePactNew from '@/pages/pactList/leasePactNew'
import CooperationPact from '@/pages/pactList/cooperationPact'
import BuyRemark from '@/pages/buyRemark/buyRemark'
import BuyModel from '@/pages/buyModel/buyModel'
import Share from '@/pages/share/share'
import Advise from '@/pages/advise/advise'

import SendGoods from '@/pages/fun/sendGoods'
import Scancode from '@/pages/fun/scancode'
import componentInBound from '@/pages/fun/componentInBound'
import componentOutBound from '@/pages/fun/componentOutBound'
import checkDevSn from '@/pages/fun/checkDevSn'

Vue.use(Router)

export default new Router({
  base: '/agent/',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        title: '服务商'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: '登录/注册'
      }
    },
    {
      path: '/registerCoach',
      name: 'RegisterCoach',
      component: RegisterCoach,
      meta: {
        title: '退押金账号'
      }
    },
    {
      path: '/ecmall/logon',
      name: 'logon',
      component: Logon,
      meta: {
        title: '登录/注册'
      }
    },
    {
      path: '/apply',
      name: 'Apply',
      component: Apply,
      meta: {
        title: '申请认证'
      }
    },
    {
      path: '/cities',
      name: 'Cities',
      component: Cities,
      meta: {
        title: '选择城市'
      }
    },
    {
      path: '/orderdetail/:id',
      name: 'Orderdetail',
      component: Orderdetail,
      meta: {
        title: '订单详情'
      }
    },
    {
      path: '/ecmall/orders',
      name: 'Order_1',
      component: Order_1,
      meta: {
        title: '我的订单'
      }
    },
    {
      path: '/checking',
      name: 'Checking',
      component: Checking,
      meta: {
        title: '申请认证'
      }
    },
    {
      path: '/income',
      name: 'Income',
      component: Income,
      meta: {
        title: '我的收入'
      }
    },
    {
      path: '/incomebydev',
      name: 'IncomeByDev',
      component: IncomeByDev,
      meta: {
        title: '我的收入'
      }
    },
    {
      path: '/incomedetail',
      name: 'Incomedetail',
      component: Incomedetail,
      meta: {
        title: '收入明细'
      }
    },
    {
      path: '/pay',
      name: 'Pay',
      component: Pay,
      meta: {
        keep_alive: true,
        title: '超级教练路考仪账单'
      }
    },
    {
      path: '/ecmall/buy',
      name: 'Buy_1',
      component: Buy_1,
      meta: {
        title: '领取路考仪'
      }
    },
    {
      path: '/ecmall/paid',
      name: 'Paid',
      component: Paid,
      meta: {
        title: '支付成功'
      }
    },
    {
      path: '/compaid',
      name: 'ComPaid',
      component: ComPaid,
      meta: {
        title: '支付成功'
      }
    },
    {
      path: '/address',
      name: 'Address',
      component: Address,
      meta: {
        title: '填写收货地址'
      }
    },
    {
      path: '/equipment',
      name: 'Equipment',
      component: Equipment,
      meta: {
        title: '我的设备'
      }
    },
    {
      path: '/equipmentdetail',
      name: 'Equipmentdetail',
      component: Equipmentdetail,
      meta: {
        title: '设备详情'
      }
    },
    {
      path: '/buyhistory',
      name: 'Buyhistory',
      component: Buyhistory
    },
    {
      path: '/incomeparticulars',
      name: 'Incomeparticulars',
      component: Incomeparticulars,
      meta: {
        title: '收入详情'
      }
    },
    {
      path: '/incomeorderdetails',
      name: 'Incomeorderdetails',
      component: Incomeorderdetails,
      meta: {
        title: '超级教练路考仪'
      }
    },
    {
      path: '/publicity',
      name: 'Publicity',
      component: Publicity,
      meta: {
        title: '服务商'
      }
    },
    {
      path: '/ecmall',
      name: 'ProductDetail_1',
      component: ProductDetail_1,
      meta: {
        title: '超级教练路考仪'
      }
    },
    {
      path: '/ecmallshare',
      name: 'ProductDetail_share',
      component: ProductDetail_share,
      meta: {
        title: '超级教练路考仪'
      }
    },
    {
      path: '/ecmallsell',
      name: 'ProductDetail_sell',
      component: ProductDetail_sell,
      meta: {
        title: '超级教练路考仪'
      }
    },
    {
      path: '/signinPact',
      name: 'SigninPact',
      component: SigninPact,
      meta: {
        title: '超级教练路考仪'
      }
    },
    {
      path: '/settlePact',
      name: 'SettlePact',
      component: SettlePact,
      meta: {
        title: '超级教练路考仪'
      }
    },
    {
      path: '/leasePact',
      name: 'LeasePact',
      component: LeasePact,
      meta: {
        title: '超级教练路考仪'
      }
    },
    {
      path: '/leasePactNew',
      name: 'LeasePactNew',
      component: LeasePactNew,
      meta: {
        title: '超级教练路考仪'
      }
    },
    {
      path: '/cooperationPact',
      name: 'CooperationPact',
      component: CooperationPact,
      meta: {
        title: '超级教练路考仪'
      }
    },
    {
      path: '/buyRemark',
      name: 'BuyRemark',
      component: BuyRemark,
      meta: {
        title: '备注'
      }
    },
    {
      path: '/buyModel',
      name: 'BuyModel',
      component: BuyModel,
      meta: {
        title: '选择车型'
      }
    },
    {
      path: '/share',
      name: 'Share',
      component: Share,
      meta: {
        title: '我要分享'
      }
    },
    {
      path: '/protocol',
      name: 'protocol',
      component: protocol,
      meta: {
        title: '科三保'
      }
    },
    {
      path: '/advise',
      name: 'advise',
      component: Advise,
      meta: {
        title: '学员协议'
      }
    },
    {
      path: '/sendGoods',
      name: 'sendGoods',
      component: SendGoods,
      meta: {
        title: '扫码发货'
      }
    }, ,
    {
      path: '/scancode',
      name: 'scancode',
      component: Scancode,
      meta: {
        title: '扫码入库'
      }
    },
    {
      path: '/component-in-bound',
      name: 'componentInBound',
      component: componentInBound,
      meta: {
        title: '科二扫码入库'
      }
    },
    {
      path: '/component-out-bound',
      name: 'componentOutBound',
      component: componentOutBound,
      meta: {
        title: '科二扫码出库'
      }
    },
    {
      path: '/check-dev-sn',
      name: 'checkDevSn',
      component: checkDevSn,
      meta: {
        title: '超级教练路考仪'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js